<div
  [id]="id"
  style="contain: paint style"
>
  <div
    *ngIf="title"
    class="px-5"
  >
    <h2 class="pt-10 font-brand text-base text-neutral-900 text-3xl">
      {{ title }}
    </h2>
  </div>
  <div
    *ngIf="heading"
    class="px-5 mt-2"
  >
    <p class="font-accent">{{ heading }}</p>
  </div>
  <div
    *ngFor="let category of categories"
    class="flex flex-col text-neutral-800 mt-3"
  >
    <div
      class="px-5 mt-2"
      *ngIf="category.title"
    >
      <h3 class="font-accent font-bold text-2xl">{{ category.title }}</h3>
    </div>
    <div
      *ngIf="category.heading"
      class="px-5 mt-3"
    >
      <p class="font-accent">{{ category.heading }}</p>
    </div>
    <div class="mt-3">
      <app-product-push-list-atom
        displayContext="marketplace_page"
        [products]="category.products"
        (navigateTo)="onNavigateTo($event)"
      ></app-product-push-list-atom>
    </div>
  </div>
</div>
